import { Pressable, View } from 'react-native';
import { useRouter } from 'expo-router';
import { useTranslation } from 'react-i18next';
import { Text } from '@/components/ui/text';
import { Icon } from '~/global/components/icon/Icon';
import { RightSidebar } from '~/layout/components/right-sidebar/RightSidebar';

export interface ChatMobileHeaderProps {}

/**
 * Mobile (tabs-layout) header for the AI Coach chat screen: back button, a
 * centered title, and a chat-history button that opens the generic right-sidebar
 * drawer ({@link RightSidebar.Drawer}) from the right. Hidden on desktop
 * (`md:hidden`), where {@link ChatHeader} + the right-sidebar list are shown.
 */
export const ChatMobileHeader = ({}: ChatMobileHeaderProps) => {
  const { t } = useTranslation('chat');
  const router = useRouter();

  const handleBack = () => {
    if (router.canGoBack()) {
      router.back();
    } else {
      router.replace('/(overview)');
    }
  };

  return (
    <View className="md:hidden h-14 flex-row items-center justify-between px-4">
      <Pressable
        accessibilityRole="button"
        accessibilityLabel={t('mobileHeader.back')}
        onPress={handleBack}
        className="h-10 w-10 items-center justify-center rounded-full active:opacity-70"
      >
        <Icon name="ArrowLeft" size={24} className="text-text-primary" />
      </Pressable>

      <Text className="font-sora-semibold text-lg text-text-primary">
        {t('mobileHeader.title')}
      </Text>

      <RightSidebar.Trigger
        size={24}
        accessibilityLabel={t('mobileHeader.history')}
      />
    </View>
  );
};
